import BaseService from '../baseServices';
import REST from '../../configs/rest';

function postOrder({ body }) {
  return BaseService.post(REST.ADMIN_ORDER, body);
}

export default {
  postOrder,
};
